import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface PunchOut {
  activityId: string;
  punchInTime: string;
  punchOutTime: string;
  workingHours: number;
  totalDayHours: number;
  isOvertime: boolean;
  isHalfDay: boolean;
  sessionStatus: string;
  isCrossDate: boolean;
  punchInDate: string;
  punchOutDate: string;
}

export type PunchOutPayload = {
  punchOutTime: string;
  notes: string;
  location: Location;
};

export interface Location {
  lat: number | null;
  lng: number | null;
}

export type PunchOutResponse = {
  success: boolean;
  message: string;
  data: PunchOut;
};

const addPunchOut = async (
  payload: PunchOutPayload
): Promise<PunchOutResponse> => {
  const { data } = await customAxios.post<PunchOutResponse>(
    "/attendance/punch-out",
    payload
  );
  return data;
};

export const useAddPunchOut = () => {
  const queryClient = useQueryClient();

  return useMutation<PunchOutResponse, AxiosError, PunchOutPayload>({
    mutationFn: addPunchOut,
    onSuccess: async (data) => {
      showNotification({
        title: "Success",
        message: data.message,
        color: "green",
      });

      await queryClient.invalidateQueries(["attendance"]);
      await queryClient.invalidateQueries(["table-attendace"]);
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to Clock Out",
        color: "red",
      }),
  });
};
